import { useEffect } from 'react';

const SCRIPT_ATTR = 'data-bl-jsonld';

export function setJsonLd(id: string, data: Record<string, unknown> | Record<string, unknown>[] | null) {
  const selector = `script[${SCRIPT_ATTR}="${id}"]`;
  const existing = document.head.querySelector<HTMLScriptElement>(selector);
  if (!data) {
    existing?.remove();
    return;
  }
  let el = existing;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute(SCRIPT_ATTR, id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

type JsonLdProps = {
  id: string;
  data: Record<string, unknown> | Record<string, unknown>[];
};

/** Injecte un script application/ld+json géré (remplacé à chaque update). */
export function JsonLd({ id, data }: JsonLdProps) {
  const serialized = JSON.stringify(data);
  useEffect(() => {
    setJsonLd(id, JSON.parse(serialized) as Record<string, unknown>);
    return () => setJsonLd(id, null);
  }, [id, serialized]);

  return null;
}
